import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Urls } from '@/lib/navigation';
import { FullPageShell } from '../FullPageShell';
import { trackSettingsTabChanged, trackHelpEmailClicked } from '@/analytics';

export type SettingsTab = 'general' | 'billing';

const tabs: { id: SettingsTab; label: string; path: string }[] = [
  { id: 'general', label: 'General', path: Urls.settings() },
  { id: 'billing', label: 'Billing', path: Urls.billing() },
];

interface SettingsShellProps {
  activeTab: SettingsTab;
  children: ReactNode;
}

export const SettingsShell = (props: SettingsShellProps) => {
  const navigate = useNavigate();

  return (
    <FullPageShell onClose={() => navigate(-1)} className="z-[60]" headerClassName="z-[61]">
      <h1 className="text-xl text-zinc-100">Settings</h1>

      <div className="mt-5 flex gap-6 border-b border-white/[0.06]">
        {tabs.map((tab) => (
          <Link
            key={tab.id}
            to={tab.path}
            replace
            onClick={() => trackSettingsTabChanged(tab.id)}
            className={cn(
              '-mb-px border-b px-0 py-2.5 text-[13px] transition-colors',
              props.activeTab === tab.id
                ? 'border-zinc-100 text-zinc-100'
                : 'border-transparent text-zinc-500 hover:text-zinc-400',
            )}
          >
            {tab.label}
          </Link>
        ))}
      </div>

      {props.children}

      <p className="mt-10 text-center text-[12px] text-zinc-600">
        Need help?{' '}
        <a
          href="mailto:hello@symbolica.ai"
          onClick={trackHelpEmailClicked}
          className="text-zinc-400 underline underline-offset-2 transition-colors hover:text-zinc-200"
        >
          Send us an email
        </a>
      </p>
    </FullPageShell>
  );
};
